<template>
  <div class="flex flex-column flex-1">
    <u-header show-back prevent-back @back="onBack">绑定邮箱</u-header>
    <div class="scrollable container flex-1 flex flex-row">
      <form name="form" class="flex-1" @submit.prevent="bind">
        <u-input type="email" class="form-control" placeholder="请输入要绑定的邮箱" v-model="email" autofocus :readonly="!rebind&&user.emailVerified">
          <span v-if="validation.hasError('email')" slot="right" class="input-error">{{validation.firstError('email')}}</span>
        </u-input>
        <u-button native-type="submit" v-longpress="()=>rebind=true" style="margin-top: 40px">
          {{!rebind&&user.emailVerified?'邮箱已绑定，长按开始重新绑定':(sent?'我已完成绑定':'绑定邮箱')}}
        </u-button>
      </form>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { Validator } from 'simple-vue-validator'
import AV from 'leancloud-storage'
export default {
  data () {
    return {
      email: this.$store.getters.user.email || '',
      // 是否已发送验证邮件
      sent: false,
      rebind: false
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  validators: {
    email: {
      debounce: 300,
      validator (v) {
        return Validator.value(v).required('邮箱必填').email('请输入有效的邮箱地址')
      }
    }
  },
  methods: {
    ...mapActions(['updateUser']),
    onBack () {
      this.$router.go(-1)
    },
    bind () {
      const user = AV.User.current()
      if (!this.rebind && this.user.emailVerified) {
        return
      } else if (user.getEmail() && this.sent) {
        user.fetch().then(() => {
          if (user.get('emailVerified')) {
            this.$toast('已完成绑定')
            this.updateUser({ emailVerified: true })
            this.$router.go(-1)
          } else {
            this.$toast('未完成绑定')
          }
        })
      } else {
        this.$validate().then(isSuccess => {
          if (isSuccess) {
            if (this.email === user.get('email')) {
              return this.$toast('邮箱并未修改')
            }
            user.setEmail(this.email).save().then(() => {
              this.updateUser({ email: this.email })
              AV.User.requestEmailVerify(this.email).then(result => {
                this.sent = true
                this.$toast('验证邮件已发送，请前往邮箱查看')
              }).catch(() => {
                this.$toast('验证邮件发送失败')
              })
            }).catch(err => {
              this.$toast(err.message || '验证邮件发送失败')
            })
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// BindEmail.vue?5ed47f5d